document.addEventListener("DOMContentLoaded", () => {
    const container = document.getElementById("facility-filter-list-content");
    if (!container) return;
    const showAllBtn = document.getElementById('facility-filter-list-show-all-btn');

    // Fetch more facilities
    showAllBtn.addEventListener('click', () => {
        loadMoreFacilities(false, null, searchLat, searchLng);
    })
    async function loadMoreFacilities(resetList = false, city = null, lat = null, lng = null) {
        if (resetList) {
            // Reset to page 1 as Server rendering isnt a thing here
            currentPage = 1;
            // Empty the UL so we can populate it with fresh Data
            container.innerHTML = "";

            if (!mapCheck()) {
                // Show the button
                showButtonFunction(false);
            }
        }

        const { area, trainingforms, conveniences } = window.getParams();


        // Prio list: Search input, Filter, Url
        let paramArea = searchTermState ? searchTermState : city ? city : area ? area[0] : null;

        const runFetch = async () => {
            const data = await fetchFacilities(paramArea, trainingforms, conveniences, lat, lng);
            if (data) {
                renderFacilities(data, container);
            }
        };

        if ('requestIdleCallback' in window) {
            requestIdleCallback(runFetch);
        } else {
            // Fallback for Safari, older Android webviews, etc.
            setTimeout(runFetch, 200);
        }
    }

    const showButtonFunction = (hide = false) => {
        if (!showAllBtn) return
        const parentDiv = showAllBtn.closest("div");
        if (hide || totalPages !== null && totalPages <= currentPage - 1) {
            utils.common.hideElement(parentDiv);
            utils.common.hideElement(showAllBtn);
            showAllBtn.style.display = "none";
        } else {
            utils.common.showElement(showAllBtn);
            utils.common.showElement(parentDiv);
            showAllBtn.style.display = "flex";
        }
    }

    window.showButtonFunction = showButtonFunction;
    window.loadMoreFacilities = loadMoreFacilities;
});
